<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ 'confirmation' | translate }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">NO</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">OK</button>
</mat-dialog-actions>
